<div class="custom-select input-mes" (keyup)="onKeyDown($event)">
    <div [id]="id" [ngClass]="status ? 'select-arrow-active select-selected' : 'select-selected'" (click)="onClickParent()" (clickOutside)="onClickedOutside($event)">
        {{selectedText}}
    </div>
    <div #select [ngClass]="status ? 'select-items' : 'select-items select-hide'">
      <div *ngFor="let element of elements; let i = index"
          [ngClass]="selectedItem === i ? 'selected-item-element' : ''"
          (click)="onClickChild(element, element.name +' '+element.year)"
          #selectItem
      >
        {{element.name}} {{element.year}}
      </div>
    </div>
</div>